<template>
	<!--新增对话框-->
	<el-dialog :title="editForm.id ? '编辑门店' : '新增门店'" :visible.sync="dialogVisible" width="1024px"
		:close-on-click-modal="false" :before-close="handleClose" top="6vh">
		<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">
			<el-form-item label="门店名称" prop="name" label-width="100px">
				<el-input v-model="editForm.name" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="门店地址" prop="address" label-width="100px">
				<el-input v-model="editForm.address" autocomplete="off" @blur="addrHand()">
					<el-button slot="append" @click="addrHand()">
						定位
					</el-button>
				</el-input>
			</el-form-item>
			<el-row>
				<el-col :span="12">
					<el-form-item label="经度" prop="longitude" label-width="100px">
						<el-input v-model="editForm.longitude" disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="纬度" prop="latitude" label-width="100px">
						<el-input v-model="editForm.latitude" disabled></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-form-item label="营业时间" prop="businessTime" label-width="100px">
				<el-input v-model="editForm.businessTime" ></el-input>
			</el-form-item>
			<el-form-item label="联系方式" prop="phone" label-width="100px">
				<el-input v-model="editForm.phone" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="图片" prop="imgs" label-width="100px">
				<VploadImg :limit="1" v-bind:file-list="fileList" :type="2" @submitImg="getImgList"></VploadImg>
			</el-form-item>
			<div style="height: 30px;"></div>
			<el-form-item label="介绍" label-width="100px" prop="content">
				<el-input v-model="editForm.introduction" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item align="center">
				<el-button type="primary" @click="submitForm('editForm')">
					保存
				</el-button>
				
			</el-form-item>
		</el-form>
	</el-dialog>
</template>

<script>
	import md5 from 'js-md5'
	import VploadImg from '../inc/VploadImgThree'
	import VploadVideo from '../inc/ComponentUploadImage'
	import TinymceEditor from '../inc/TinymceEditor'
	export default {
		components: {
			TinymceEditor,
			VploadImg,
			VploadVideo,
		},
		data() {
			return {
				userIdList: [],
				value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
				editForm: {
					address: '',
					imgs: [],
					introduce: '',
					latitude: '',
					longitude: '',
					phone: '',
					businessTime: '08:00-22:00',
					name: '',
					userId: '',
					userName: '',
				},
				tTime: [],
				fileList: [],
				urlList: [],
				dialogVisible: false,
				editFormRules: {
					name: [{
						required: true,
						message: '请输入社区名称',
						trigger: 'blur'
					}],
					businessTime: [{
						required: true,
						message: '请输入营业时间',
						trigger: 'blur'
					}, ],
					phone: [{
						required: true,
						message: '请输入联系方式',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入社区地址',
						trigger: 'blur'
					}, ],
					contact: [{
						required: true,
						message: '请输入社区联系人',
						trigger: 'blur'
					}, ],
				},
			}
		},
		methods: {
			resetForm(formName) {
				this.$refs[formName].resetFields()
				this.dialogVisible = false
				this.editForm = {}
				this.fileList = []
				this.urlList = []
			},
			getImgList(url, add) {
				if (add == 1) {
					this.editForm.cover = url
				} else if (add == 0) {
					this.editForm.cover = ''

				}

			},

			handleClose() {
				this.resetForm('editForm')
			},
			addrHand() {
				if (
					this.editForm.address == '' ||
					this.editForm.address == null ||
					this.editForm.address == undefined
				) {
					this.$message({
						message: '请先填写详细地址',
						type: 'error',
					})
				}
				var that = this
				var address = 'address=' + this.editForm.address
				var cc =
					'/ws/geocoder/v1?' +
					address +
					'&callback=QQmap&key=GSHBZ-I723W-FXKRN-OU4R4-RBERV-V4B4Q&output=jsonpIKSygovT9bwmR3Hh8qfembCcN6gZn0P'
				var dss = md5(cc)
				$.ajax({
					type: 'get',
					dataType: 'jsonp',
					cache: true,
					data: {
						address: this.editForm.address, //具体的地址
						key: 'GSHBZ-I723W-FXKRN-OU4R4-RBERV-V4B4Q', // 填申请到的腾讯keyw
						output: 'jsonp', //返回格式：支持JSON/JSONP，默认JSON
						sig: dss,
					},
					jsonp: 'callback',
					jsonpCallback: 'QQmap',
					url: 'https://apis.map.qq.com/ws/geocoder/v1?',
					success: function(json) {
						console.log(json)
						if (json.status == 0) {
							that.editForm.latitude = json.result.location.lat //维度
							that.editForm.longitude = json.result.location.lng //经度
							that.$forceUpdate()
						} else {
							that.$message.error(
								'获取该位置经纬度失败,请填写详细地址，包括省市区街道',
							)
						}
					},
					error: function(err) {},
				})
			},
			submitForm(formName) {
				var icon = []
				var copy = []

				this.urlList.forEach((item) => {
					icon.push({
						url: item,
					})
				})

				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.editForm.imgs = icon
						this.$axios
							.post(
								'/admin/store/' +
								(!this.editForm.id ? 'addStore' : 'updateStore'),
								this.editForm,
							)
							.then((res) => {
								this.$message({
									showClose: true,
									message: '恭喜你，操作成功',
									type: 'success',
									onClose: () => {
										this.$emit('refreshDataList')
									},
								})
								this.dialogVisible = false
								this.resetForm(formName)
							})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			},

			init(id) {
				if (id) {
					this.dialogVisible = true
					this.$axios.post('/admin/store/getStoreInfo', {
							id: id,
						})
						.then((res) => {
							this.editForm = res.data
							var obj = {
								url: res.data.cover
							}
							this.fileList.push(obj)

						})

				} else {
					this.fileList = []
					this.dialogVisible = true
				}

			},
		},
	}
</script>

<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>